import axios from 'axios'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { toast } from 'react-toastify'

dayjs.extend(utc)
dayjs.extend(timezone)
import {
  apiURL,
  appVersion,
  commonHeadersWeb,
  platformWeb,
  publicApiURL,
  getCountryCode,
} from 'src/consumer/services'
import {
  isCommonResponseSuccessful,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getDataWithParams } from './profileService'

export const makeQuoteFavorite = async (id) => {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.put(`${apiURL}/api/secure/Quote/${id}/favorite`, null, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

export const makeQuoteUnfavorite = async (id) => {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.delete(`${apiURL}/api/secure/Quote/${id}/unfavorite`, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

export const getArticleById = async (articleId) => {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/article/${articleId}?languageCode=${sessionStorage.getItem(
        'languageCode',
      )}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

export const makeCourseFavorite = async (id, toBeMadeFavorite) => {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.put(
      `${apiURL}/api/secure/course/${id}/${toBeMadeFavorite ? 'favorite' : 'unfavorite'}`,
      {},
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

export const saveJournal = async (id, body, callsource = 'default', callsourceid = 'default') => {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.post(
      `${apiURL}/api/secure/journals/${id}/ans?src=${callsource}&src-id=${callsourceid}`,
      body,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (e) {
    console.log(e)
  }
}

export const saveAssessment = async (
  id,
  body,
  callsource = 'default',
  callsourceid = 'default',
) => {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.post(
      `${apiURL}/api/secure/assessment/${id}/ans?src=${callsource}&src-id=${callsourceid}`,
      body,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (e) {
    console.log(e)
  }
}

export const getJournalBasedRecommendation = async (id) => {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(`${apiURL}/api/secure/journals/${id}/recommend`, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return response
  } catch (error) {
    console.log(error)
    return error
  }
}

export const deleteJournalEntry = async (journalEntryId) => {
  const token = localStorage.getItem('token')
  const data = {}

  try {
    const response = await axios.put(
      `${apiURL}/api/secure/journals-entry/${journalEntryId}/delete`,
      data,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
    return error
  }
}

export async function getDataWithoutParams(url, withoutCustomHeaders = false) {
  const token = localStorage.getItem('token')
  try {
    const res = await axios.get(`${apiURL}${url}`, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(withoutCustomHeaders
          ? {}
          : {
              ...commonHeadersWeb,
              'ef-user-country-code': getCountryCode(),
              'ef-app-language': sessionStorage.getItem('languageCode'),
            }),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

/** Same as getDataWithoutParams but uses publicApiURL (papi). Use for public/unauthenticated endpoints like service-provider on public pages. */
export async function getPublicDataWithoutParams(url, withoutCustomHeaders = false) {
  try {
    const res = await axios.get(`${publicApiURL}${url}`, {
      headers: withoutCustomHeaders
        ? {}
        : {
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function postDataWithoutParams(url, data) {
  const token = localStorage.getItem('token')
  try {
    // const os = `${platform.os.family}`.toLowerCase()
    const res = await axios.post(`${apiURL}${url}`, data, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function putDataWithoutParams(url, data) {
  const token = localStorage.getItem('token')
  try {
    // const os = `${platform.os.family}`.toLowerCase()
    const res = await axios.put(`${apiURL}${url}`, data, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function putDataWithParams(url, data, params = {}) {
  const token = localStorage.getItem('token')
  try {
    // const os = `${platform.os.family}`.toLowerCase()
    const res = await axios.put(`${apiURL}${url}`, data, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
      params: params,
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getAgoraToken(eventId, asHost = false) {
  const token = localStorage.getItem('token')
  const languageCode = sessionStorage.getItem('languageCode')

  if (asHost) {
    try {
      const res = await axios.get(
        `${apiURL}/api/secure/teacher/token/videocall?languageCode=${languageCode}&platform=${platformWeb}&eventId=${eventId}`,
        {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  } else {
    try {
      const res = await axios.get(
        `${apiURL}/api/secure/live/token/videocall?languageCode=${languageCode}&platform=${platformWeb}&eventId=${eventId}`,
        {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  }
}

export async function getPublicAgoraToken(sessionSlug, options = {}) {
  try {
    const params = {
      slug: sessionSlug,
    }
    if (options.shortKey) params.shortKey = options.shortKey

    const res = await axios.get(`${apiURL}/api/nc/video-call/join`, {
      headers: {
        ...commonHeadersWeb,
        ...(options.recaptchaToken && { 'X-Recaptcha-Token': options.recaptchaToken }),
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
      params,
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function preflightPublicSessionJoin({ sessionSlug, shortKey, recaptchaToken }) {
  try {
    const params = {
      slug: sessionSlug,
    }
    if (shortKey) params.shortKey = shortKey

    const res = await axios.get(`${apiURL}/api/nc/video-call/preflight`, {
      headers: {
        ...commonHeadersWeb,
        ...(recaptchaToken && { 'X-Recaptcha-Token': recaptchaToken }),
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
      params,
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function logPublicUserJoined(bookedEventId) {
  try {
    // Collect device info (non-blocking)
    const { collectDeviceInfoForLogging } = await import('./deviceInfoCollector')
    const { deviceDetails, ipPromise } = collectDeviceInfoForLogging()
    
    // Get IP if available (with timeout to avoid blocking)
    let ipAddress = null
    try {
      ipAddress = await Promise.race([
        ipPromise,
        new Promise((resolve) => setTimeout(() => resolve(null), 500)), // 500ms timeout
      ])
    } catch (e) {
      // IP fetch failed, continue without it
    }

    await axios.post(`${apiURL}/api/nc/video-call/join-log?bookedEventId=${bookedEventId}`, {
      deviceInfo: {
        ...deviceDetails,
        ipAddress, // May be null if fetch is still in progress
      },
    }, {
      headers: {
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
  } catch (error) {
    console.error('Error logging user join:', error)
  }
}
export async function logPublicUserLeft(bookedEventId) {
  try {
    await axios.post(`${apiURL}/api/nc/video-call/leave-log?bookedEventId=${bookedEventId}`, {
      headers: {
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
  } catch (error) {
    console.error('Error logging user leave:', error)
  }
}

export async function getAgoraChatToken() {
  const token = localStorage.getItem('token')
  const languageCode = sessionStorage.getItem('languageCode')
  try {
    const res = await axios.get(`${apiURL}/api/secure/user-chat/token/user`, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getAgoraSignalingToken(screenDeviceConfigId) {
  const token = localStorage.getItem('token')
  if (!screenDeviceConfigId) {
    return
  }
  try {
    const res = await axios.get(
      `${apiURL}/api/secure/signaling/token/user-device?deviceId=${screenDeviceConfigId}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function sendShowImageCommandToChamberScreen(chamberRoomId, imageType, payload) {
  console.log('sendShowImageCommandToChamberScreen', chamberRoomId, imageType, payload)
  if (!(chamberRoomId && imageType)) {
    return Promise.reject(new Error('chamberRoomId and imageType are required'))
  }
  const token = localStorage.getItem('token')

  try {
    const res = await axios.post(
      `${apiURL}/api/secure/teacher/control/checked-in-screen/show-temp-image?chamberRoomId=${chamberRoomId}&imageType=${imageType}`,
      payload,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    if (res?.status === 200 && isCommonResponseSuccessfulV2(res)) {
      toast.success('Request successful')
    } else {
      toast.error('Request failed')
    }
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function sendReloadChamberRoomScreenSignal(chamberRoomId, payload = {}) {
  if (!chamberRoomId) {
    return
  }
  const token = localStorage.getItem('token')

  try {
    const res = await axios.post(
      `${apiURL}/api/secure/teacher/control/checked-in-screen/ask-to-refresh-page?chamberRoomId=${chamberRoomId}`,
      payload,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    if (res?.status === 200 && isCommonResponseSuccessfulV2(res)) {
      toast.success('Chamber room will now reload/refresh.')
    } else {
      toast.error('Request failed')
    }
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function askCheckedInChamberScreenToPollNextAction(chamberRoomId) {
  console.log('[MENTOR PORTAL] askCheckedInChamberScreenToPollNextAction called', {
    chamberRoomId,
    hasChamberRoomId: !!chamberRoomId,
    timestamp: new Date().toISOString()
  })

  if (!chamberRoomId) {
    console.warn('[MENTOR PORTAL] askCheckedInChamberScreenToPollNextAction: chamberRoomId is missing!', {
      chamberRoomId,
      timestamp: new Date().toISOString()
    })
    return
  }
  const token = localStorage.getItem('token')

  const requestUrl = `${apiURL}/api/secure/teacher/control/checked-in-screen/ask-to-poll-next-action?chamberRoomId=${chamberRoomId}`
  console.log('[MENTOR PORTAL] Making POST request to trigger chamber screen polling', {
    url: requestUrl,
    chamberRoomId,
    hasToken: !!token,
    timestamp: new Date().toISOString()
  })

  try {
    const res = await axios.post(
      requestUrl,
      {},
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    
    console.log('[MENTOR PORTAL] askCheckedInChamberScreenToPollNextAction response', {
      status: res?.status,
      statusText: res?.statusText,
      data: res?.data,
      isSuccess: res?.status === 200 && isCommonResponseSuccessfulV2(res),
      timestamp: new Date().toISOString()
    })

    const normalizedMessage = String(res?.data?.message || '')
      .trim()
      .toLowerCase()
    const isMissingChamberScreenDevice =
      res?.data?.code === 52386 ||
      normalizedMessage.includes('unable to find device id for the chamber room')

    if (res?.status === 200 && isCommonResponseSuccessfulV2(res)) {
      // Use notification panel if available, otherwise fall back to toast
      if (window.addNotification) {
        window.addNotification('Attempted Fast Track Connect', 'success', 5000)
      } else {
        toast.success('Attempted Fast Track Connect')
      }
      console.log('[MENTOR PORTAL] Successfully triggered chamber screen polling', {
        chamberRoomId,
        timestamp: new Date().toISOString()
      })
    } else if (isMissingChamberScreenDevice) {
      console.warn(
        '[MENTOR PORTAL] Skipping chamber screen polling because no chamber screen device is configured',
        {
          status: res?.status,
          data: res?.data,
          chamberRoomId,
          timestamp: new Date().toISOString(),
        },
      )
    } else {
      console.error('[MENTOR PORTAL] Failed to trigger chamber screen polling - invalid response', {
        status: res?.status,
        data: res?.data,
        chamberRoomId,
        timestamp: new Date().toISOString()
      })
      // Use notification panel if available, otherwise fall back to toast
      if (window.addNotification) {
        window.addNotification('Error fast tracking connection', 'error', 5000)
      } else {
        toast.error('Error fast tracking connection')
      }
    }
    return res
  } catch (err) {
    console.error('[MENTOR PORTAL] Error calling askCheckedInChamberScreenToPollNextAction', {
      error: err,
      message: err?.message,
      response: err?.response,
      status: err?.response?.status,
      data: err?.response?.data,
      chamberRoomId,
      timestamp: new Date().toISOString()
    })
    // Show error notification
    if (window.addNotification) {
      window.addNotification('Error fast tracking connection', 'error', 5000)
    } else {
      toast.error('Error fast tracking connection')
    }
    return err
  }
}

/**
 * Get teacher chamber room screens status
 * @param {AbortSignal} [signal] - Optional AbortSignal to cancel the request (e.g. on component unmount)
 * @returns {Promise<Array>} Array of chamber room screen statuses
 */
export async function getTeacherChamberRoomScreensStatus(signal = null) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/teacher/chamber-room/screens/status`,
      {
        signal,
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      }
    )

    if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
      const data = response?.data?.data
      return data?.chamberRoomScreenStatuses || []
    }

    return []
  } catch (error) {
    if (axios.isCancel(error) || error?.name === 'AbortError') {
      return []
    }
    console.error('[CHAMBER STATUS] Error fetching teacher chamber room screens status:', error)
    return []
  }
}

/**
 * Check if the chamber room screen is online/connected
 * @param {string} chamberRoomId - The chamber room ID to check
 * @param {string} screenId - Optional screen ID to check specific screen
 * @returns {Promise<'online'|'offline'|'unknown'>} Status of the chamber screen
 */
export async function checkChamberScreenStatus(chamberRoomId, screenId = null) {
  if (!chamberRoomId) {
    console.warn('[CHAMBER STATUS] checkChamberScreenStatus: chamberRoomId is missing!')
    return 'unknown'
  }

  try {
    // Use the new API endpoint to get all screen statuses
    const screenStatuses = await getTeacherChamberRoomScreensStatus()
    
    // Find all screens for the specific chamber room
    const roomScreens = screenStatuses.filter(
      (status) => status.chamberRoomId === chamberRoomId
    )
    
    if (roomScreens.length === 0) {
      // If room not found in status list, return unknown
      console.warn('[CHAMBER STATUS] Chamber room not found in status list', {
        chamberRoomId,
        availableRooms: screenStatuses.map(s => s.chamberRoomId),
        timestamp: new Date().toISOString()
      })
      return 'unknown'
    }
    
    // If screenId is provided, find the specific screen status
    if (screenId) {
      const specificScreen = roomScreens.find((screen) => screen.screenId === screenId)
      if (specificScreen) {
        const status = specificScreen.status === 'up' ? 'online' : 'offline'
        // Status is returned without logging to avoid console spam during polling
        return status
      }
      // If specific screen not found, return unknown
      return 'unknown'
    }
    
    // If no specific screenId, check if any screen is up (room is online if at least one screen is up)
    const hasOnlineScreen = roomScreens.some((screen) => screen.status === 'up')
    const status = hasOnlineScreen ? 'online' : 'offline'
    
    // Status is returned without logging to avoid console spam during polling (called every 30 seconds)
    return status
  } catch (error) {
    console.warn('[CHAMBER STATUS] Error checking chamber screen status', {
      chamberRoomId,
      error: error?.message,
      timestamp: new Date().toISOString()
    })
    return 'unknown'
  }
}

export async function sendAgoraChatMessage(data) {
  const token = localStorage.getItem('token')
  const languageCode = sessionStorage.getItem('languageCode')
  try {
    const res = await axios.post(
      `${apiURL}/api/secure/user-chat/send/message?messageType=text`,
      data,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function sendAgoraCustomMessage(data) {
  const token = localStorage.getItem('token')
  const languageCode = sessionStorage.getItem('languageCode')
  try {
    const res = await axios.post(
      `${apiURL}/api/secure/user-chat/send/message?messageType=custom`,
      data,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getConversationWithThisUser(userId, page) {
  const token = localStorage.getItem('token')
  if (token) {
    try {
      const res = await axios.get(
        `${apiURL}/api/secure/user-chat/get/conversation?withUserId=${userId}&page=${page}&pageSize=20`,
        {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  }
}

export async function getHotlineToken(eventId, forMentor = true, callType = 'booked-event') {
  const token = localStorage.getItem('token')
  const languageCode = sessionStorage.getItem('languageCode')

  if (forMentor) {
    try {
      const res = await axios.get(
        `${apiURL}/api/secure/teacher/token/videocall?languageCode=${languageCode}&platform=${platformWeb}&eventId=${eventId}&callType=${callType}`,
        {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  } else {
    try {
      const res = await axios.get(
        `${apiURL}/api/secure/clinic-assistant/token/videocall?languageCode=${languageCode}&platform=${platformWeb}&eventId=${eventId}`,
        {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  }
}

export async function startAgoraSessionRecording(eventId, uidRecording, recordingProvider) {
  const token = localStorage.getItem('token')
  try {
    const res = await axios.get(
      `${apiURL}/api/secure/live/recording/start`,
      {
        params: {
          eventId,
          ...(recordingProvider ? { recordingProvider } : {}),
        },
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function queryAgoraSessionRecordingStatus(
  eventId,
  resourceId,
  sid,
  recordingProvider,
) {
  const token = localStorage.getItem('token')
  try {
    const res = await axios.get(
      `${apiURL}/api/secure/live/recording/status`,
      {
        params: {
          eventId,
          ...(recordingProvider ? { recordingProvider } : {}),
        },
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function stopAgoraSessionRecording(
  eventId,
  uidRecording,
  resourceId,
  sid,
  recordingProvider,
) {
  const token = localStorage.getItem('token')
  try {
    const res = await axios.get(
      `${apiURL}/api/secure/live/recording/stop`,
      {
        params: {
          eventId,
          ...(recordingProvider ? { recordingProvider } : {}),
        },
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function requestLiveSessionTranscription(
  eventId,
  transcriptionProvider,
  languageCode,
) {
  const token = localStorage.getItem('token')
  try {
    const res = await axios.get(`${apiURL}/api/secure/live/transcription/request`, {
      params: {
        eventId,
        ...(transcriptionProvider ? { transcriptionProvider } : {}),
        ...(languageCode ? { languageCode } : {}),
      },
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function queryLiveSessionTranscriptionStatus(eventId, transcriptionProvider) {
  const token = localStorage.getItem('token')
  try {
    const res = await axios.get(`${apiURL}/api/secure/live/transcription/status`, {
      params: {
        eventId,
        ...(transcriptionProvider ? { transcriptionProvider } : {}),
      },
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getBookedSessionsForUser(page = 1) {
  const token = localStorage.getItem('token')
  if (token) {
    try {
      const res = await axios.get(
        `${apiURL}/api/secure/user/booked-slots?page=${page}&pageSize=10`,
        {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  }
}

export async function getBookedSessionsForMentor(
  page = 1,
  listingApiSignature = '/api/secure/teacher/booked-slots/all/paginated',
  passedParams = {},
) {
  const token = localStorage.getItem('token')
  if (token) {
    try {
      // Build params object, handling arrays properly for query string
      const params = {
        page: passedParams.page !== undefined ? passedParams.page : page,
        size: passedParams.size || passedParams.pageSize || 20,
        ...passedParams,
      }

      // Remove pageSize if size is set
      if (params.size) {
        delete params.pageSize
      }

      // Handle array parameters - axios will serialize them correctly
      // eventTypes, statusIds, paymentStatusIds should be arrays
      const res = await axios.get(`${apiURL}${listingApiSignature}`, {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
        params: params,
        paramsSerializer: {
          indexes: null, // Use bracket notation for arrays: eventTypes[]=value1&eventTypes[]=value2
        },
      })
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  }
}

export async function getAllCoursesCategoryItemsForPublic(
  page = 1,
  categoriesString,
  minDuration,
  maxDuration,
  courseType,
  type,
  tagsString,
  technique,
) {
  console.log(courseType, type)
  const queryParams = []
  queryParams.push(`page=${page}`)
  queryParams.push(`pageSize=10`)
  if (categoriesString) queryParams.push(`categories=${categoriesString}`)
  if (minDuration) queryParams.push(`minDuration=${minDuration}`)
  if (maxDuration) queryParams.push(`maxDuration=${maxDuration}`)
  if (courseType) queryParams.push(`courseType=${courseType}`)
  if (type) queryParams.push(`type=${type}`)
  if (tagsString) queryParams.push(`tags=${tagsString}`)
  if (technique) queryParams.push(`techniqueId=${technique}`)

  // Append query parameters to the URL
  let urlAdditionForQuery = ''
  if (queryParams.length > 0) {
    urlAdditionForQuery += `?${queryParams.join('&')}`
  }

  try {
    const res = await axios.get(`${apiURL}/api/external/search/course/list${urlAdditionForQuery}`, {
      headers: {
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getAllBreatheForPublic(page = 1) {
  try {
    const res = await axios.get(
      `${publicApiURL}/external/prana-vayu/list?page=${page}&pageSize=10`,
      {
        headers: {
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

// remove intent
export async function getAllTechniqueForPublic(page = 1) {
  try {
    const res = await axios.get(
      `${publicApiURL}/api/external/technique/list?page=${page}&pageSize=10`,
      {
        headers: {
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getPaginatedDataWithAPIString(
  apiString,
  alreadyHasQuestionMark = false,
  page = 1,
  pageSize = 10,
) {
  try {
    const res = await axios.get(
      `${apiURL}${apiString}${
        alreadyHasQuestionMark
          ? `&page=${page}&pageSize=${pageSize}`
          : `?page=${page}&pageSize=${pageSize}`
      }`,
      {
        headers: {
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

// export async function getAssessmentData(string, isSlug = true) {
//   let conditionalApiText
//   if (isSlug) {
//     conditionalApiText = `${apiURL}/api/secure/feature?feature=assessment&slug=${string}`
//   } else {
//     conditionalApiText = `${apiURL}/api/secure/feature?feature=assessment&id=${string}`
//   }
//   const token = localStorage.getItem('token')
//   const headers = {
//     ...commonHeadersWeb,
//     'ef-user-country-code': localStorage.getItem('countryCode'),
//     'ef-app-language': sessionStorage.getItem('languageCode'),
//   }
//   if (token) {
//     headers['Authorization'] = `Bearer ${token}`
//   }
//   try {
//     const res = await axios.get(conditionalApiText, {
//       headers: headers,
//     })
//     return res
//   } catch (err) {
//     console.log(err)
//     return err
//   }
// }

export async function getQuoteData(string, isSlug = true) {
  let conditionalApiText
  if (isSlug) {
    conditionalApiText = `${apiURL}/api/quote?slug=${string}`
  } else {
    conditionalApiText = `${apiURL}/api/quote?id=${string}`
  }

  try {
    const res = await axios.get(conditionalApiText, {
      headers: {
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getCourseData(courseId) {
  const token = localStorage.getItem('token')

  try {
    const res = await axios.get(
      `${apiURL}/api/secure/v2/explore/courses/${courseId}?languageCode=${sessionStorage.getItem(
        'languageCode',
      )}&appVersion=${appVersion}&platform=${platformWeb}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getMentalStateType(id) {
  try {
    const res = await axios.get(`${apiURL}/api/mental-state-type?id=${id}`, {
      headers: {
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getJournalDataForUserBySlug(text, isSlug = true) {
  const languageCode = sessionStorage.getItem('languageCode')
  let apiParamText
  if (isSlug) {
    apiParamText = `slug=${text}&languageCode=${languageCode}`
  } else {
    apiParamText = `id=${text}&languageCode=${languageCode}`
  }
  const token = localStorage.getItem('token')
  const headers = {
    ...commonHeadersWeb,
    'ef-user-country-code': localStorage.getItem('countryCode'),
    'ef-app-language': sessionStorage.getItem('languageCode'),
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  try {
    const res = await axios.get(`${apiURL}/api/secure/feature?feature=journal&${apiParamText}`, {
      headers: headers,
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export const prepareDataForPlan = (days, minutes, timeString, profileData) => {
  let studentPersonalizeObject = profileData.personalize.studentPersonalize
  const localTimezoneOffsetInMinutes = dayjs().utcOffset()

  return {
    ...studentPersonalizeObject,
    preferences: {
      convenientTime: {
        // "location": {
        //     "address": "",
        //     "city": "",
        //     "country": "",
        //     "countryCode": "",
        //     "id": "",
        //     "lat": 0,
        //     "lng": 0,
        //     "pincode": "",
        //     "resolvedBy": "",
        //     "state": "",
        //     "stateCode": ""
        // },
        time: dayjs(timeString)
          .subtract(localTimezoneOffsetInMinutes, 'minutes')
          .format('YYYY-MM-DD HH:mm:ss'), //instant
        // "type": ""
      },
      planDuration: days, //days
      sessionTime: minutes, // minutes
      withMentor: false,
    },
  }
}

export function getBodyForSavingNotes(bookedEventId, content) {
  return {
    bookedEventId: bookedEventId,
    // "assessmentReports": [
    //     "string"
    // ],
    content: content,
    // "prescriptionId": "string",
    // "id": "string",
  }
}

export const saveNotes = async (role, body) => {
  const token = localStorage.getItem('token')

  try {
    if (role === 'user') {
      const response = await axios.post(`${apiURL}/api/secure/live/user-notes/save`, body, {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      })
      return response
    } else if (role === 'panelist') {
      const response = await axios.post(
        `${apiURL}/api/secure/teacher/panelist-1on1-notes/save`,
        body,
        {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
        },
      )
      return response
    } else if (role === 'mentor') {
      const response = await axios.post(`${apiURL}/api/secure/teacher/1on1-notes/save`, body, {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      })
      return response
    }
    return 'provide valid role'
  } catch (e) {
    console.log(e)
  }
}

export async function getNotesOfBookedEvent(bookedEventId, role) {
  const token = localStorage.getItem('token')
  let apiString
  switch (role) {
    case 'mentor':
      apiString = '/api/secure/teacher/1on1-notes/get'
      break
    case 'panelist':
      apiString = '/api/secure/teacher/panelist-1on1-notes/get'
      break
    case 'user':
      apiString = '/api/secure/live/user-notes/get'
      break
    default:
      break
  }

  try {
    const res = await axios.get(`${apiURL}${apiString}?eventId=${bookedEventId}`, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
    })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getUserPrescriptionOfEvent(bookedEventId) {
  const token = localStorage.getItem('token')

  try {
    const res = await axios.get(
      `${apiURL}/api/secure/patient-user/prescription/get-by-eventId?eventId=${bookedEventId}&send-auxiliary-data=true`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getPrescriptionOfEventAsClinicAssistant(bookedEventId) {
  const token = localStorage.getItem('token')

  try {
    const res = await axios.get(
      `${apiURL}/api/secure/clinic-assistant/prescription/get-by-eventId?eventId=${bookedEventId}&send-auxiliary-data=true`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

// Downloads the server-generated prescription PDF for a booked event as a clinic assistant.
// Returns the raw axios response (responseType: 'blob') so the caller can trigger the file
// download and read the content-disposition filename. Errors are intentionally not swallowed
// here so the caller can distinguish success from failure.
export async function downloadPrescriptionPdfOfEventAsClinicAssistant(bookedEventId) {
  const token = localStorage.getItem('token')

  return axios.get(
    `${apiURL}/api/secure/clinic-assistant/prescription/pdf?eventId=${bookedEventId}`,
    {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...commonHeadersWeb,
        'ef-user-country-code': getCountryCode(),
        'ef-app-language': sessionStorage.getItem('languageCode'),
      },
      responseType: 'blob',
    },
  )
}

export const markBookedEventLog = async (bookedEventId, action, role, ioState) => {
  // action: JOIN, LEAVE, REFRESH, CAMERA_ON, CAMERA_OFF, MIC_ON, MIC_OFF, etc.
  // role: endUser, panelist, mentor
  const token = localStorage.getItem('token')

  try {
    // Collect device info synchronously (no network calls, < 5ms)
    const { getClientDeviceInfo } = await import('./deviceInfoCollector')
    const clientDeviceInfo = getClientDeviceInfo()

    const response = await axios.post(
      `${apiURL}/api/secure/live/booked-event/log`,
      { 
        bookedEventId, 
        action, 
        role, 
        ioState,
        clientDeviceInfo,
      },
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (e) {
    console.log(e)
  }
}
export const markBookedEventLogForPublicEvent = async (sessionSlug, action, ioState) => {
  // action: JOIN, LEAVE, REFRESH, CAMERA_ON, CAMERA_OFF, MIC_ON, MIC_OFF, etc.
  const token = localStorage.getItem('token')

  try {
    // Collect device info synchronously (no network calls, < 5ms)
    const { getClientDeviceInfo } = await import('./deviceInfoCollector')
    const clientDeviceInfo = getClientDeviceInfo()

    const response = await axios.post(
      `${apiURL}/api/nc/video-call/log`,
      { 
        sessionSlug, 
        action, 
        ioState,
        clientDeviceInfo,
      },
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (e) {
    console.log(e)
  }
}

/**
 * Fetch waiting screen engagement config for logged-in users
 * This returns the music tracks and games available while waiting for the session
 * 
 * API: GET /api/secure/online/booked-event/waiting-engagement?bookedEventId={bookedEventId}
 * 
 * Response structure:
 * {
 *   "code": 2000,
 *   "data": {
 *     "engagementConfig": {
 *       "enabled": true,
 *       "engagement": {
 *         "music": { "tracks": [{ "id": "...", "name": "...", "mediaId": "..." }] },
 *         "games": { "available": ["music", "breathing", "memory", "bubbles"] }
 *       }
 *     }
 *   }
 * }
 */
export async function getWaitingEngagementConfig(bookedEventId) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/online/booked-event/waiting-engagement`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
        params: {
          bookedEventId,
        },
      },
    )
    
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      const engagementConfig = response?.data?.data?.engagementConfig
      
      // Return the engagement object only if enabled
      if (engagementConfig?.enabled && engagementConfig?.engagement) {
        return {
          success: true,
          engagement: engagementConfig.engagement,
        }
      }
    }
    
    return { success: false, engagement: null }
  } catch (e) {
    console.log('Error fetching waiting engagement config:', e)
    return { success: false, engagement: null }
  }
}

/**
 * Fetch signed URL for engagement music track
 * 
 * For public pages (/v/*): Uses /api/nc/video-call/engagement/music-url
 * For secured pages (/l/*): Uses /api/secure/online/booked-event/engagement/music-url
 * 
 * @param {object} params
 * @param {string} params.slug - Public session slug (for /v/* routes)
 * @param {string} params.bookedEventId - Booked event ID (for /l/* routes)
 * @param {string} params.shortKey - Optional session key/OTP
 * @param {string} params.mediaId - The music track mediaId
 * @returns {Promise<{success: boolean, signedUrl: string|null}>}
 */
/**
 * Music URL API error codes:
 * - 2000: Success - use data.signedUrl for HLS playback
 * - 48764: Too early - use waitUntilInMs to schedule retry
 * - 48765: Session ended - stop, no retries
 * - 4132: Missing mediaId - client bug
 * - 4142: No engagement music / invalid timing - treat as "no music"
 * - 4143: Media not in engagement - refresh join response
 * - 4133: Not allowed for user - permission issue
 * - 5313: Media file not found - refresh join
 * - 5315: Private media not allowed - permission issue
 * - 5316: Media not ready (HLS processing) - retry with backoff
 */
export const MUSIC_URL_ERROR_CODES = {
  SUCCESS: 2000,
  TOO_EARLY: 48764,
  SESSION_ENDED: 48765,
  MISSING_MEDIA_ID: 4132,
  NO_ENGAGEMENT_MUSIC: 4142,
  MEDIA_NOT_IN_ENGAGEMENT: 4143,
  NOT_ALLOWED: 4133,
  MEDIA_NOT_FOUND: 5313,
  PRIVATE_MEDIA: 5315,
  MEDIA_NOT_READY: 5316,
}

export async function getEngagementMusicUrl({ slug, bookedEventId, shortKey, mediaId }) {
  const token = localStorage.getItem('token')

  if (!mediaId) {
    return { success: false, signedUrl: null, error: 'mediaId is required', code: MUSIC_URL_ERROR_CODES.MISSING_MEDIA_ID }
  }

  try {
    // Determine which endpoint to use based on available params
    const isPublicRoute = !!slug
    const isSecuredRoute = !!bookedEventId && !slug
    
    let response
    
    if (isPublicRoute) {
      // Public route: /api/nc/video-call/engagement/music-url
      const params = { slug, mediaId }
      if (shortKey) params.shortKey = shortKey
      
      response = await axios.get(
        `${apiURL}/api/nc/video-call/engagement/music-url`,
        {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
          params,
        },
      )
    } else if (isSecuredRoute) {
      // Secured route: /api/secure/online/booked-event/engagement/music-url
      response = await axios.get(
        `${apiURL}/api/secure/online/booked-event/engagement/music-url`,
        {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': sessionStorage.getItem('languageCode'),
          },
          params: {
            bookedEventId,
            mediaId,
          },
        },
      )
    } else {
      return { success: false, signedUrl: null, error: 'Either slug or bookedEventId is required' }
    }
    
    const responseCode = response?.data?.code
    const responseData = response?.data?.data
    
    // Success case
    if (response?.status === 200 && responseCode === MUSIC_URL_ERROR_CODES.SUCCESS) {
      const signedUrl = responseData?.signedUrl
      if (signedUrl) {
        return { success: true, signedUrl, code: responseCode }
      }
    }
    
    // Handle specific error codes with appropriate metadata
    const errorMessage = response?.data?.message || 'Failed to fetch music URL'
    
    // Determine retry behavior based on error code
    let canRetry = false
    let retryAfterMs = null
    let shouldRefreshJoin = false
    let isPermissionError = false
    let isSessionEnded = false
    
    switch (responseCode) {
      case MUSIC_URL_ERROR_CODES.TOO_EARLY:
        canRetry = true
        retryAfterMs = responseData?.waitUntilInMs || 60000
        break
      case MUSIC_URL_ERROR_CODES.SESSION_ENDED:
        isSessionEnded = true
        break
      case MUSIC_URL_ERROR_CODES.MEDIA_NOT_IN_ENGAGEMENT:
      case MUSIC_URL_ERROR_CODES.MEDIA_NOT_FOUND:
        shouldRefreshJoin = true
        break
      case MUSIC_URL_ERROR_CODES.NOT_ALLOWED:
      case MUSIC_URL_ERROR_CODES.PRIVATE_MEDIA:
        isPermissionError = true
        break
      case MUSIC_URL_ERROR_CODES.MEDIA_NOT_READY:
        canRetry = true
        retryAfterMs = 5000 // Retry after 5 seconds with backoff
        break
      case MUSIC_URL_ERROR_CODES.NO_ENGAGEMENT_MUSIC:
        // Treat as "no music available" - don't retry
        break
      default:
        // Unknown error - allow retry with backoff
        canRetry = true
        retryAfterMs = 10000
        break
    }
    
    return { 
      success: false, 
      signedUrl: null, 
      error: errorMessage, 
      code: responseCode,
      canRetry,
      retryAfterMs,
      shouldRefreshJoin,
      isPermissionError,
      isSessionEnded,
    }
  } catch (e) {
    console.log('Error fetching engagement music URL:', e)
    // Network error - allow retry
    return { 
      success: false, 
      signedUrl: null, 
      error: 'Network error',
      canRetry: true,
      retryAfterMs: 5000,
    }
  }
}

export async function markAuditorBookedEventCheckInLog(
  auditorId,
  monitoredPractitionerId,
  action,
  ioState,
) {
  // action: JOIN, LEAVE, etc.
  const token = localStorage.getItem('token')

  try {
    // Collect device info synchronously (no network calls, < 5ms)
    const { getClientDeviceInfo } = await import('./deviceInfoCollector')
    const clientDeviceInfo = getClientDeviceInfo()

    const response = await axios.post(
      `${apiURL}/api/secure/practitioner/auditor/booked-event/log`,
      {
        clientDeviceInfo,
      },
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
        params: {
          'auditor-id': auditorId,
          'monitored-practitioner-id': monitoredPractitionerId,
          action,
          'io-state.mic': ioState.mic,
          'io-state.camera': ioState.camera,
        },
      },
    )
    return response
  } catch (e) {
    console.log(e)
  }
}

// serves assessment, journal, activity-plan, mentor, article, technique BUT NOT course
export async function getFeatureList(apiParam, page = 1, externalParams = {}) {
  const token = localStorage.getItem('token')
  const headers = {
    ...commonHeadersWeb,
    'ef-user-country-code': localStorage.getItem('countryCode'),
    'ef-app-language': sessionStorage.getItem('languageCode'),
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  if (token) {
    try {
      const res = await axios.get(`${apiURL}/api/external/feature/list`, {
        headers: {
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
        params: {
          feature: apiParam,
          page: page,
          pageSize: 10,
          ...externalParams,
        },
      })
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  } else {
    try {
      const res = await axios.get(`${apiURL}/api/external/feature/list`, {
        headers: {
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
        params: {
          feature: apiParam,
          page: page,
          pageSize: 10,
          ...externalParams,
        },
      })
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  }
}

// serves journal, assessment, mentor, course BUT NOT actvity-plan, article
export async function getFeatureItemBySlug(apiParam, text, isSlug = true, externalParams = {}) {
  const token = localStorage.getItem('token')
  const languageCode = sessionStorage.getItem('languageCode')
  let apiParamText = {}
  if (isSlug) {
    apiParamText = { slug: text }
  } else {
    apiParamText = { id: text }
  }
  const headers = {
    ...commonHeadersWeb,
    'ef-user-country-code': localStorage.getItem('countryCode'),
    'ef-app-language': sessionStorage.getItem('languageCode'),
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  if (token) {
    try {
      const res = await axios.get(`${apiURL}/api/secure/feature`, {
        headers: headers,
        params: {
          feature: apiParam,
          ...apiParamText,
          languageCode: languageCode,
          ...externalParams,
        },
      })
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  } else {
    try {
      const res = await axios.get(`${apiURL}/api/feature`, {
        headers: headers,
        params: {
          feature: apiParam,
          ...apiParamText,
          languageCode: languageCode,
          ...externalParams,
        },
      })
      return res
    } catch (err) {
      console.log(err)
      return err
    }
  }
}

// to remove
export async function getAssessmentData(string, isSlug = true) {
  try {
    const res = await getFeatureItemBySlug('assessment', string, isSlug)
    if (res.status === 200 && isCommonResponseSuccessful(res.data.code)) {
      return { status: 200, data: res.data.data.assessment }
    }
  } catch (err) {
    console.log(err)
    return err
  }
}

// to remove
export async function getJournalDataBySlug(text, isSlug = true) {
  try {
    const res = await getFeatureItemBySlug('journal', text, isSlug)
    if (res.status === 200 && isCommonResponseSuccessful(res.data.code)) {
      return { status: 200, data: res.data.data.journal }
    }
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getRestDataById(text, externalParams = {}, mentorIds) {
  const resp = await getDataWithParams(`/api/secure/teacher/search/rest`, {
    ids: text,
    mentorIds: mentorIds,
  })
  if (resp.status === 200) {
    const foundRest = resp.data?.content?.find((rest) => rest.id === text)
    return { status: 200, data: foundRest }
  } else {
    toast.error('Something went wrong')
  }
}

export async function getMentalStateTypeById(text, externalParams = {}) {
  const resp = await getDataWithParams('/api/mental-state-type', { id: text })
  if (resp.status === 200) {
    return resp
  } else {
    toast.error('Something went wrong.')
  }
}

export async function getMentalStateTypeList(page = 1) {
  const resp = await getDataWithParams('/api/external/mental-state-type/list', { page })
  if (resp.status === 200) {
    return resp
  } else {
    toast.error('Something went wrong.')
  }
}

export async function getArticleData(string, isSlug = true) {
  const languageCode = sessionStorage.getItem('languageCode')

  try {
    let res
    if (isSlug) {
      res = await axios.get(
        `${apiURL}/api/article?id=&slug=${string}&languageCode=${languageCode}`,
        {
          headers: {
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': languageCode,
          },
        },
      )
    } else {
      res = await axios.get(
        `${apiURL}/api/article?id=${string}&slug=&languageCode=${languageCode}`,
        {
          headers: {
            ...commonHeadersWeb,
            'ef-user-country-code': getCountryCode(),
            'ef-app-language': languageCode,
          },
        },
      )
    }
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

export async function getPopularAndMyTimersFromServer() {
  // const response = await getDataWithParams('/api/secure/timer/all-including-my-private/list')
  const response = await getDataWithParams('/api/secure/timer/all-including-my-private/list')
  if (response.status === 200) {
    return response.data
  } else {
    return []
  }
}
export async function getMyTimersOnlyFromServer() {
  // const response = await getDataWithParams('/api/secure/timer/all-including-my-private/list')
  const response = await getDataWithParams('/api/secure/user/timers')
  if (response.status === 200) {
    return response.data
  } else {
    return []
  }
}

// BOOKING REQUEST RELATED - CLINIC ASSISTANT SIDE
export async function saveBookingRequest(params, body) {
  const token = localStorage.getItem('token')

  const eventType = params?.eventType
  const mode = params?.mode
  const clinicBrandId = params?.clinicBrandId
  const clinicLocationId = params?.clinicLocationId

  try {
    const response = await axios.post(
      `${apiURL}/api/secure/clinic-assistant/booking-request/new?eventType=${eventType}&mode=${mode}&clinicBrandId=${clinicBrandId}&clinicLocationId=${clinicLocationId}`,
      body,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (e) {
    console.log(e)
  }
}

export async function getBookingRequestsForAssistant(startTime) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/clinic-assistant/booking-request/all?startTime=${startTime}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

export async function cancelBookingRequestFuncForAssistant(bookingRequestId) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/clinic-assistant/booking-request/cancel?bookingRequestId=${bookingRequestId}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

// BOOKING REQUEST RELATED - MENTOR SIDE

export async function informBookingRequestReceivedForMentor(
  bookingRequestId,
  commType,
  commProvider,
) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.put(
      `${apiURL}/api/secure/teacher/booking-request/log/receive?bookingRequestId=${bookingRequestId}&commType=${commType}&commProvider=${commProvider}`,
      {},
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (e) {
    console.log(e)
  }
}

export async function getBookingRequestsForMentor(startTime, showAll) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/teacher/booking-request/all?startTime=${startTime}&sendIncludingUnavailable=${showAll}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

export async function rejectBookingRequestFuncForMentor(bookingRequestId) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/teacher/booking-request/reject?bookingRequestId=${bookingRequestId}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

export async function acceptBookingRequestFuncForMentor(bookingRequestId) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/teacher/booking-request/accept?bookingRequestId=${bookingRequestId}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

//// CHAMBER ROOM RELATED

export async function getBookedSessionsInSelectedChamberRoomsBwUtcTime(
  chamberRoomsArray,
  selectedDateUtcStartTime,
  selectedDateUtcEndTime,
) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/clinic-assistant/chamber-room/booked-event/list?chamberRoomsIds=${chamberRoomsArray?.join(
        ',',
      )}&startTime=${selectedDateUtcStartTime}&endTime=${selectedDateUtcEndTime}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

export async function getBookingRequestsInSelectedChamberRoomsBwUtcTime(
  chamberRoomsArray,
  selectedDateUtcStartTime,
  selectedDateUtcEndTime,
) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/clinic-assistant/chamber-room/booking-request/list?chamberRoomsIds=${chamberRoomsArray?.join(
        ',',
      )}&startTime=${selectedDateUtcStartTime}&endTime=${selectedDateUtcEndTime}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

export async function sendDaySummaryToDoctor(selectedDateUtcStartTime, selectedDateUtcEndTime) {
  const token = localStorage.getItem('token')

  try {
    const response = await axios.get(
      `${apiURL}/api/secure/teacher/day-summary?startTime=${selectedDateUtcStartTime}&endTime=${selectedDateUtcEndTime}`,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          ...commonHeadersWeb,
          'ef-user-country-code': getCountryCode(),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      },
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

export async function cancelBookedSession(
  cancelBookedSessionApiUrl = '/api/secure/teacher/booked-slot/cancel',
  eventId,
  reason = null,
  refundType = 'none',
  eventSlug = null,
) {
  const token = localStorage.getItem('token')
  const languageCode = sessionStorage.getItem('languageCode')

  try {
    // Detect if this is a support portal API
    const isSupportPortalApi = cancelBookedSessionApiUrl?.includes('/api/secure/cc/support/')
    
    // Use appropriate base URL based on portal
    let baseURL = apiURL
    if (isSupportPortalApi) {
      // Dynamically import supportApiURL to avoid circular dependencies
      const { supportApiURL } = await import('src/supportPortal/services/services')
      baseURL = supportApiURL
    }
    
    // Build request body for POST request
    const requestBody = {
      refundType: refundType,
    }
    
    // Include bookedEventId or bookedEventSlug (prefer slug if available)
    if (eventSlug) {
      requestBody.bookedEventSlug = eventSlug
    } else if (eventId) {
      requestBody.bookedEventId = eventId
    }
    
    // Include reason if provided
    if (reason) {
      requestBody.reason = reason
    }
    
    // Use appropriate headers based on portal
    const headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      'Content-Type': 'application/json',
      'ef-user-country-code': getCountryCode(),
      'ef-app-language': sessionStorage.getItem('languageCode'),
    }
    
    if (isSupportPortalApi) {
      // Import support portal headers
      const { commonHeadersMPWeb } = await import('src/supportPortal/services/services')
      Object.assign(headers, commonHeadersMPWeb)
    } else {
      Object.assign(headers, commonHeadersWeb)
    }
    
    const res = await axios.post(`${baseURL}${cancelBookedSessionApiUrl}`, requestBody, { headers })
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
